import { render } from "./OpticalExperiment.vue?vue&type=template&id=e9236c68"
import script from "./OpticalExperiment.vue?vue&type=script&lang=js"
export * from "./OpticalExperiment.vue?vue&type=script&lang=js"

import "./OpticalExperiment.vue?vue&type=style&index=0&id=e9236c68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__